import { useTranscriptionsState } from '@modules/transcriptions/useTranscriptionsState';
import { Badge, Tooltip } from '@mui/material';
import { MouseEvent } from 'react';
import { Note } from 'src/@types/notes-transcription';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { ActionsBarButtonStyled } from '../../shared/styles';
import { useActionBarState } from '../../useActionBarState';
import { useTranscriptionNotesState } from './useTranscriptionNotesState';

export const GatheringTranscription = ({
  onClick,
}: { onClick: () => void }) => {
  const { translate } = useLocales();
  const { openAction, setReopen, isOpen, setIsOpen } = useActionBarState();

  const {
    note: openedNote,
    activeTranscriptionNote,
    setNote,
  } = useTranscriptionsState();

  const { isTranscriptionStarted } = useTranscriptionNotesState();

  const handleOpenNote = (event: MouseEvent<HTMLButtonElement>, note: Note) => {
    event.stopPropagation();
    if (openedNote?._id === note._id) return onClick();
    setNote(note);
    if (isOpen) {
      setReopen('notes');
      setIsOpen(false);
    }
  };

  return (
    <>
      {isTranscriptionStarted && !!activeTranscriptionNote && (
        <Tooltip
          title={translate('actions_bar.active_transcription')}
          placement="left"
          arrow
        >
          <Badge
            badgeContent={
              activeTranscriptionNote.loadingTranscription ? (
                <Iconify icon="eos-icons:loading" width={12} height={12} />
              ) : (
                ''
              )
            }
            color={
              activeTranscriptionNote.loadingTranscription
                ? 'primary'
                : undefined
            }
            sx={{ '& .MuiBadge-badge': { padding: 0 } }}
          >
            <ActionsBarButtonStyled
              variant="outlined"
              color={
                openAction === 'notes' &&
                openedNote?._id === activeTranscriptionNote._id
                  ? 'primary'
                  : 'inherit'
              }
              onClick={(e) => handleOpenNote(e, activeTranscriptionNote)}
            >
              <Iconify icon="tabler:file-text-spark" />
            </ActionsBarButtonStyled>
          </Badge>
        </Tooltip>
      )}
    </>
  );
};
